import React, {useEffect, useState} from 'react';

export function InputSearch({className = '', value, handleChange}) {
  const [search, setSearch] = useState(value || '');

  useEffect(() => {
    if (search === value) {
      return;
    }
    const tm = setTimeout(() => {
      handleChange('search', search)
    }, 500);

    return () => clearTimeout(tm);
  }, [search, value, handleChange]);

  return <React.Fragment>
    <input className={"input" + (className ? " " + className : "")}
           placeholder="Поиск"
           name="search"
           value={search}
           onChange={(e) => setSearch(e.target.value)} />
  </React.Fragment>;
}
